var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCloudOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 11C14.5523 11 15 11.4477 15 12V22.5858L17.2929 20.2929C17.6834 19.9024 18.3166 19.9024 18.7071 20.2929C19.0976 20.6834 19.0976 21.3166 18.7071 21.7071L14.7071 25.7071C14.3166 26.0976 13.6834 26.0976 13.2929 25.7071L9.29289 21.7071C8.90237 21.3166 8.90237 20.6834 9.29289 20.2929C9.68342 19.9024 10.3166 19.9024 10.7071 20.2929L13 22.5858V12C13 11.4477 13.4477 11 14 11Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 3C14.3708 3 12.763 3.66239 11.5765 4.81076C10.1032 4.3991 8.58547 4.77117 7.45367 5.5911C6.32926 6.40567 5.51544 7.71612 5.49958 9.24216C3.99691 10.0351 3 11.5879 3 13.3437C3 15.9535 5.21266 17.9267 7.70551 17.9996L10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16H7.75035C6.21708 15.9483 5 14.7437 5 13.3437C5 12.2116 5.74499 11.1963 6.86287 10.8285C7.33344 10.6737 7.61975 10.1977 7.53595 9.70943C7.36525 8.71479 7.82143 7.79434 8.62702 7.21075C9.43741 6.62367 10.5044 6.45185 11.4379 6.88474C11.8512 7.07637 12.3418 6.96447 12.6311 6.61258C13.4599 5.6044 14.7159 5 16.0833 5C18.7043 5 20.7586 7.30896 20.4718 9.76861C20.4169 10.2391 20.6996 10.6835 21.149 10.8332C22.2604 11.2035 23 12.2157 23 13.3437C23 14.7415 21.8652 15.93 20.3807 15.9971H18C17.4477 15.9971 17 16.4448 17 16.9971C17 17.5493 17.4477 17.9971 18 17.9971C18.8214 17.9971 20.4717 17.995 20.4717 17.995C22.9796 17.8817 25 15.8553 25 13.3437C25 11.588 24.003 10.0342 22.4989 9.24182C22.4667 5.86399 19.5918 3 16.0833 3Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloudOutline);
export default __webpack_public_path__ + "static/media/download_cloud_outline.f4057c4f02a93462284cbe82ba4d80d2.svg";
export { ForwardRef as ReactComponent };